import { render } from "./registration-edit-incentive-program-dialog.vue?vue&type=template&id=35d77e36&scoped=true&ts=true"
import script from "./registration-edit-incentive-program-dialog.vue?vue&type=script&lang=ts"
export * from "./registration-edit-incentive-program-dialog.vue?vue&type=script&lang=ts"

import "./registration-edit-incentive-program-dialog.vue?vue&type=style&index=0&id=35d77e36&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d77e36"]])

export default __exports__